import React from 'react';
import HTMLReactParser from 'html-react-parser/lib/index';
import './speechcard.css';

function SpeechCard({ backgroundColor, textColor, outline, body }) {
  return (
    <div className="card" data-scrollbar-color="blue" style={{ backgroundColor, color: textColor, border: outline }}>
      {HTMLReactParser(body)}
    </div>
  );
}

export default SpeechCard;
